/* import __COLOCATED_TEMPLATE__ from './cvda-numeric-filter.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'embercom/services/intl';
import { type DataType } from 'embercom/objects/inbox/conversation-attribute-descriptor';
import { type Comparison } from 'embercom/objects/inbox/search/predicate-group';

interface Signature {
  Element: HTMLElement;
  Args: {
    selected?: string;
    onSelect: (value: string) => void;
    type: DataType;
    onComparisonSelect: (comparison: Comparison) => void;
    comparisonSelected: Comparison;
  };
}

export default class CvdaNumericFilter extends Component<Signature> {
  @service declare intl: IntlService;

  get radioButtons() {
    return [
      {
        value: 'eq',
        label: this.intl.t('inbox.search.filters.more-filters.is'),
      },
      {
        value: 'gt',
        label: this.intl.t('inbox.search.filters.more-filters.more-than'),
      },
      {
        value: 'lt',
        label: this.intl.t('inbox.search.filters.more-filters.less-than'),
      },
    ];
  }

  @action onSelect(value: string) {
    this.args.onSelect(value);
  }
  @action setSelectedRadioButtonValue(value: 'lt' | 'gt' | 'eq') {
    this.args.onComparisonSelect(value);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Search::CvdaNumericFilter': typeof CvdaNumericFilter;
  }
}
